export default __webpack_public_path__ + "static/media/About Us - Banner 2.bc20cd9b.jpg";